export const extractWeight = (code) => {
    const weightPart = code.slice(-6, -1);
    return Number(weightPart) / 1000;
};